<template>
	<div class="saidao-bg">
		<div class="title">
			<p style="height: 55px;"></p>
			<!-- <img style="width:188px" src="../../assets/image/match/title2.png" alt=""> -->
		</div>
		<div class="roadgroup" id="road-block1">
				<div class="text text1">
					<div class="text-title">产品设计组（仅面向东莞市内企业和单位）</div>
					<div class="text-content">该组仅面向东莞市内的注册企业和单位举办，征集和表彰东莞好产品、好设计。参赛产品（项目）须为已开发和已量产面市的产品，需以企业、
机构、公司等单位的名义参赛。</div>
					<div class="type" style="margin-top: 20px">本组内设立7大专项赛类别：</div>
					<div class="type-text">
						<div class="type-text-name">智能移动终端专项赛</div>
						<div class="type-text-name">高端装备专项赛</div>
						<div class="type-text-name">泛家居专项赛</div>
						<div class="type-text-name">婴童用品及玩具专项赛</div>
						<div class="type-text-name">医疗器械及适老化用品专项赛</div>
						<div class="type-text-name">纺织服装鞋帽专项赛</div>
						<div class="type-text-name" style="width: auto">综合类专项赛（即前6类之外的产品设计项目）</div>
					</div>
				</div>
				<div class="text text2">
					<div class="text-title">创新企业组（仅面向东莞市内企业和单位）</div>
					<div class="text-content">面向注册地在东莞市的企事业单位，本组征集和评选出东莞市具有优秀设计水平的企业，于2021-2022年间，在工业设计创新发展方面取得重大的成果，其运用设计创新的发展模式具有示范和引领价值。本组需以企业或单位名义参赛。通过镇街、市级行业协会推荐、企业自荐的方式参赛。
					</div>
				</div>
				<div class="text text3">
					<div class="text-title">概念设计组（面向全球征集）</div>
					<div class="text-content">组面向全球征集概念性创新设计，特别是可以与东莞制造、东莞产业相对接、相结合、可产业化的概念设计项目，以及未量产、未投入市场的创意设计作品。
					</div>
					<div class="type">本组内设立7大专项赛类别：</div>
					<div class="type-text">
						<div class="type-text-name">智能移动终端专项赛</div>
						<div class="type-text-name">高端装备专项赛</div>
						<div class="type-text-name">泛家居专项赛</div>
						<div class="type-text-name">婴童用品及玩具专项赛</div>
						<div class="type-text-name">医疗器械及适老化用品专项赛</div>
						<div class="type-text-name">纺织服装鞋帽专项赛</div>
						<div class="type-text-name" style="width: auto">综合类专项赛（即前6类之外的产品设计项目）</div>
					</div>
			</div>
		</div>
		<div class="gangaotai-bg">
			<p class="txt" id="road-block2">本赛道专为面向港澳台地区的企业和设计师而设定。已面市的创新产品项目和未面市的概念设计类项目均可参赛。</p>
		</div>
		<div class="qiye-bg" id="road-block3">
			<p class="txt">本赛道面向东莞市产业、行业的“龙头”企业，国家级、省级、市级“工业设计中心”企业、“专精特新”企业，结合企业的实际设计需求，设立企业设计命题专项赛。</p>
			<p class="txt">企业命题赛以旭麓新材料大赛为背景，由龙头企业提供相关奖励，命题企业拥有专题赛的冠名权，享有专题赛获奖作品的知识产权。本专题赛由龙头企业出题，利用旭麓新材料组织资源，对接相关的设计高校和设计机构，大赛协助其开展相关的“湾区共创设计工作坊”，开展设计攻关和项目创新。企业命题赛的参赛作品除了在本专题赛获奖，优秀项目还可晋级到主赛道参加大赛决赛。</p>
		</div>
	</div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
.saidao-bg {
	height: 1787px;
  margin: auto;
  // background: url('../../assets/image/match/saidao-bg.jpg') no-repeat center top;
}
.title {
  padding-top: 150px;
}

.roadgroup {
	height: 863px;
	margin: auto;
	// background: url('../../assets/image/match/main-saidao-bg.jpg') no-repeat 0 top;
	padding: 135px 0 0 90px;
	box-sizing: border-box;
	.text {
		width: 906px;
		padding: 0 50px;

		font-size: 20px;
		color: white;

		.text-title {
			text-align: center;
			color: white;
			font-weight: bold;
		}

		.text-content {
			margin-top: 10px;
			line-height: 25px;
			text-indent: 25px;
			text-align: justify;
			font-size: 14px
		}

		.type {
			font-size: 16px;
			margin-top: 10px;
			font-weight: bold;
		}
	}
	.text1 {height: 220px;}
	.type-text {
		overflow: hidden;font-size: 14px;
	}

	.type-text-name {
		float: left;
		position: relative;
		margin-right: 24px;
		margin-top: 10px;
		padding-left: 18px;
		width: 190px;

		&:nth-child(4n+4) {
			margin-right: 0;
		}
	}

	.type-text-name::before {
		content: '';
		position: absolute;
		width: 10px;
		height: 10px;
		left: 3px;
		top: 5px;
		transform: rotate(45deg);
		background-color: white;

	}

	.text2 {
		margin-top: 50px;height: 150px;
	}

	.text3 {
		margin-top: 55px;
	}
}

.title {
	font-size: 38px;
	font-weight: bold;
	color: rgb(31, 0, 2);
	text-align: center;
	// margin-top: 219px;
	margin-bottom: 50px;
}

.gangaotai-bg {
	height: 173px;
  margin-top: 75px;
  // background: url('../../assets/image/match/gangaotai-bg.jpg') no-repeat 0 top;
	.txt {
		padding: 90px 0 0 84px;line-height: 22px;font-weight: 700;
	}
}
.qiye-bg {
	height: 179px;
  margin-top: 75px;
	padding-top: 90px;
	padding-left: 84px;
  // background: url('../../assets/image/match/qiye-bg.jpg') no-repeat 0 top;
	.txt {
		line-height: 26px;font-weight: 700;text-indent: 25px;width: 900px;margin-top: 4px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Match/roadgroup.vue